/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ValidationResult = {
	Correct: 'Correct',
	Warning: 'Warning',
	Error: 'Error',
} as const;
export type ValidationResult = (typeof ValidationResult)[keyof typeof ValidationResult];

export function instanceOfValidationResult(value: any): boolean {
	for (const key in ValidationResult) {
		if (Object.prototype.hasOwnProperty.call(ValidationResult, key)) {
			if (ValidationResult[key as keyof typeof ValidationResult] === value) {
				return true;
			}
		}
	}
	return false;
}

export function ValidationResultFromJSON(json: any): ValidationResult {
	return ValidationResultFromJSONTyped(json, false);
}

export function ValidationResultFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ValidationResult {
	return json as ValidationResult;
}

export function ValidationResultToJSON(value?: ValidationResult | null): any {
	return value as any;
}

export function ValidationResultToJSONTyped(
	value: any,
	ignoreDiscriminator: boolean
): ValidationResult {
	return value as ValidationResult;
}
